import React, { useEffect } from "react";
import "./PaymentResult.css";

export default function PaymentResult({ status }) {
    const success = status === "success";
    const title = success ? "Payment successful" : "Payment unsuccessful";

    useEffect(() => {
        const previousTitle = document.title;
        document.title = `${title} | Rahper`;
        return () => { document.title = previousTitle; };
    }, [title]);

    return (
        <main className={`payment-result ${success ? "payment-result--success" : "payment-result--failed"}`}>
            <header className="payment-result__brand">
                <img src={`${process.env.PUBLIC_URL}/app/logo2.png`} alt="Rahper" />
            </header>
            <section className="payment-result__card" aria-labelledby="payment-result-title">
                <div className="payment-result__icon" aria-hidden="true">
                    <svg viewBox="0 0 48 48" fill="none">
                        {success ? <path d="m12 25 8 8 17-18" /> : <path d="m16 16 16 16m0-16L16 32" />}
                    </svg>
                </div>
                <p className="payment-result__eyebrow">PAYMENT UPDATE</p>
                <h1 id="payment-result-title">{title}</h1>
                <p className="payment-result__description">
                    {success
                        ? "Thank you! Your payment has been completed. You can return to the app to view your latest payment details."
                        : "We couldn’t complete your payment. Please return to the app to check the payment status before trying again."}
                </p>
                <div className="payment-result__next">
                    <span className="payment-result__next-icon" aria-hidden="true">{success ? "✓" : "i"}</span>
                    <div>
                        <h2>{success ? "You’re all set" : "What to do next"}</h2>
                        <p>{success
                            ? "You can safely close this page and return to the app."
                            : "Check your connection and payment method. If an amount was deducted, check with your bank or contact support in the app before paying again."}</p>
                    </div>
                </div>
                <p className="payment-result__help">Need help? Contact support through the app.</p>
            </section>
            <footer className="payment-result__footer">Rahper · A better way to ride</footer>
        </main>
    );
}
